module.exports = new __parcel__URL__("glovo.4bf3bf05.png").toString();